import React from 'react';
import SMReputationListView from 'components/reputations/SMReputationListView';
import SMSearchPagerView from 'components/search/SMSearchPagerView';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMRestClient from 'lib/SMRestClient';

class SMUserReputationListView extends React.Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
    };
  }
  
  componentDidMount() {
    
  }
  
  render() {
    
    const user = this.props.user;
    let authRows = [];
    
    if (user.is_verified_facebook) {
      authRows.push(<li key="facebook"><i className="fa fa-check"></i>{I18n.t("dashboard.label_000098")}</li>);
    }
    if (user.is_verified_email) {
      authRows.push(<li key="email"><i className="fa fa-check"></i>{I18n.t("dashboard.label_000095")}</li>);
    }
    if (user.is_verified_tel) {
      authRows.push(<li key="tel"><i className="fa fa-check"></i>{I18n.t("dashboard.label_000096")}</li>);
    }
    
    return(
      <div className="site-main">
        <div className="page__even page__padding">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-4">
                <div className="ta-c">
                  <img src={user.profile_image} alt={user.name} className="side-user__icon" />
                </div>
                <h1 className="side-user__name">{user.name}</h1>
                <div className="side-user__text">
                  <p>{user.profile}</p>
                </div>
              </div>
              <div className="col-sm-12 col-md-8">
                <div className="mod-review">
                  <h2 className="page-subtitle">ホストからのレビュー</h2>
                  <ul className="mod-review__head">
                    <li className="mod-review__head-star">
                      <a>{SMRenderHelper.renderReviewStars(user.reputation_score)}</a>
                    </li>
                    <li className="mod-review__head-rating" itemProp="ratingValue">{user.reputation_score}</li>
                    <li itemProp="reviewCount">
                      <a className="space-head__list-number">{user.reputation_count}件</a>
                    </li>
                  </ul>
                  <SMReputationListView reputated="User" reputations={this.props.reputations} />
                </div>                
                <SMSearchPagerView 
                  delegate={this}
                  perPage={this.props.perPage}
                  totalCount={this.props.totalCount}
                  currentPage={this.props.currentPage}
                  options={{className: "details__main-nav"}}
                  links={SMRestClient.parseLinkString(this.props.linkString)} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
}
export default SMUserReputationListView;



// WEBPACK FOOTER //
// ./app/javascript/components/users/SMUserReputationListView.jsx